import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as actions from './actions';

const initialState = {
  cottage: {},
  error: {},
  isLoading: false,
  isUpdating: false,
  list: [],
  nextPage: null,
  replyFormId: null,
  success: {},
};

const setFetchReviewsRequest = (state) => update(state, {
  error: { $set: {} },
  isLoading: { $set: true },
  nextPage: { $set: null },
  success: { $set: {} },
});

const setFetchReviewsSuccess = (state, action) => update(state, {
  isLoading: { $set: false },
  list: { $set: state.list.concat(action.payload.list) },
  nextPage: { $set: action.payload.nextPage },
});

const setFetchReviewsFailure = (state, action) => update(state, {
  error: { $set: action.payload.error },
  isLoading: { $set: false },
  nextPage: { $set: null },
});

const setFetchPublicCottageRequest = (state) => update(state, {
  error: { $set: {} },
  success: { $set: {} },
});

const setFetchPublicCottageSuccess = (state, action) => update(state, {
  cottage: { $set: action.payload.cottage },
});

const setFetchPublicCottageFailure = (state, action) => update(state, {
  error: { $set: action.payload.error },
});

const setPostReviewRequest = (state) => update(state, {
  isUpdating: { $set: true },
});

const setPostReviewSuccess = (state) => update(state, {
  // isUpdating: { $set: false },
  success: { $set: { code: 'reviewSaved' } },
});

const setPostReviewFailure = (state, action) => update(state, {
  isUpdating: { $set: false },
  error: { $set: action.payload.error },
});

const setPostReviewReplyRequest = (state) => update(state, {
  isUpdating: { $set: true },
});

const setPostReviewReplySuccess = (state, action) => update(state, {
  isUpdating: { $set: false },
  list: {
    $set: state.list.map((review) => (review.id === action.payload.id ?
      { ...review, reply: action.payload.reply } :
      review
    )),
  },
  replyFormId: { $set: null },
  success: { $set: { code: 'reviewSaved' } },
});

const setPostReviewReplyFailure = (state, action) => update(state, {
  error: { $set: action.payload.error },
  isUpdating: { $set: false },
});

const setReplyFormId = (state, action) => update(state, {
  replyFormId: { $set: action.payload.id },
});

const setResetList = (state) => update(state, {
  error: { $set: {} },
  list: { $set: [] },
  nextPage: { $set: null },
  success: { $set: {} },
  isUpdating: { $set: false },
});

const setDeleteRequest = (state) => update(state, {
  isUpdating: { $set: true },
});

const setDeleteSuccess = (state) => update(state, {
  error: { $set: {} },
  success: { $set: { code: 'reviewDeleted' } },
  isUpdating: { $set: false },
});

const setDeleteFailure = (state, action) => update(state, {
  error: { $set: action.payload.error },
  isUpdating: { $set: false },
});

export default handleActions({
  [actions.FETCH_REVIEWS_REQUEST]: setFetchReviewsRequest,
  [actions.FETCH_REVIEWS_SUCCESS]: setFetchReviewsSuccess,
  [actions.FETCH_REVIEWS_FAILURE]: setFetchReviewsFailure,

  [actions.FETCH_PUBLIC_COTTAGE_REQUEST]: setFetchPublicCottageRequest,
  [actions.FETCH_PUBLIC_COTTAGE_SUCCESS]: setFetchPublicCottageSuccess,
  [actions.FETCH_PUBLIC_COTTAGE_FAILURE]: setFetchPublicCottageFailure,

  [actions.POST_REVIEW_REQUEST]: setPostReviewRequest,
  [actions.POST_REVIEW_SUCCESS]: setPostReviewSuccess,
  [actions.POST_REVIEW_FAILURE]: setPostReviewFailure,

  [actions.POST_REVIEW_REPLY_REQUEST]: setPostReviewReplyRequest,
  [actions.POST_REVIEW_REPLY_SUCCESS]: setPostReviewReplySuccess,
  [actions.POST_REVIEW_REPLY_FAILURE]: setPostReviewReplyFailure,

  [actions.REVIEWS_SET_REPLY_FORM_ID]: setReplyFormId,
  [actions.REVIEWS_RESET_LIST]: setResetList,

  [actions.DELETE_REVIEW_REPLY_REQUEST]: setDeleteRequest,
  [actions.DELETE_REVIEW_REQUEST]: setDeleteRequest,
  [actions.DELETE_REVIEW_SUCCESS]: setDeleteSuccess,
  [actions.DELETE_REVIEW_REPLY_SUCCESS]: setDeleteSuccess,
  [actions.DELETE_REVIEW_REPLY_FAILURE]: setDeleteFailure,
  [actions.DELETE_REVIEW_FAILURE]: setDeleteFailure,
}, initialState);
